import { defineMessages } from 'react-intl';

export default defineMessages({
  breadcrumbEmployeeRoleList: {
    id: 'employeeRole.breadcrumb.list',
    defaultMessage: 'Employee Role List',
  },
  employeeRolesTitle: {
    id: 'employeeRole.list.title',
    defaultMessage: 'Employee Roles',
  },
  no: {
    id: 'employeeRole.list.table.label.no',
    defaultMessage: 'No',
  },
  employeeRoleName: {
    id: 'employeeRole.list.table.label.employeeRole',
    defaultMessage: 'Employee Role',
  },
  employeeRoleDescription: {
    id: 'employeeRole.list.table.label.employeeRoleDescription',
    defaultMessage: 'Role Description',
  },
  labelCurrentStatus: {
    id: 'employeeRole.list.table.label.currentStatus',
    defaultMessage: 'Current Status',
  },
  labelAction: {
    id: 'employeeRole.list.table.label.labelAction',
    defaultMessage: 'Action',
  },
  activate: {
    id: 'employeeRole.list.table.activate',
    defaultMessage: 'Activate',
  },
  deactivate: {
    id: 'employeeRole.list.table.deactivate',
    defaultMessage: 'Deactivate',
  },
  active: {
    id: 'employeeRole.list.table.active',
    defaultMessage: 'Active',
  },
  deactive: {
    id: 'employeeRole.list.table.deactive',
    defaultMessage: 'Deactive',
  },
  btnCreateRole: {
    id: 'employeeRole.list.table.btnCreateRole',
    defaultMessage: 'Create New Employee Roles',
  },
  notifActivatedSuccess: {
    id: 'employeeRole.list.notif.activated.success',
    defaultMessage: 'Activated Success',
  },
  notifDeactivatedSuccess: {
    id: 'employeeRole.list.notif.deactivated.success',
    defaultMessage: 'Deactivated Success',
  },
});
